import Radio from '@material-ui/core/Radio';
import { withStyles } from '@material-ui/core/styles';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';

const CssRadio = withStyles({
    root: {
      color: '#083c7c',
      '&$checked': {
        color: '#083c7c',
      },
    },
    checked: {},
  })((props) => <Radio color="default" {...props} />);

export default function RadioButtonsGroup(props) {
    //console.log(props.value)
  return (
    <FormControl component="fieldset" >
      {props.label && <FormLabel component="legend">{props.label}</FormLabel>}
      <RadioGroup  
        name={props.name} 
        id={props.id} 
        value={props.value} 
        onChange={props.onChange} 
        row={props.row}
      >
        {
            props.data?.map((item) => {
              return (<FormControlLabel value={item.value} control={<CssRadio />} label={item.display} key={item.value} />)
            })

          }
        
      </RadioGroup>
    </FormControl>
  );
}